import { ErrorHandler, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { ProductService } from './demo/service/product.service';
import { CountryService } from './demo/service/country.service';
import { CustomerService } from './demo/service/customer.service';
import { EventService } from './demo/service/event.service';
import { IconService } from './demo/service/icon.service';
import { NodeService } from './demo/service/node.service';
import { PhotoService } from './demo/service/photo.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsAdalAngular6Module, MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { environment } from 'src/environments/environment';
import { AppGlobals } from './app.global';
import { AuthGuard } from './_guards/auth.guard';
import { LoaderService } from './_services/loader.service';
import { LoaderInterceptor } from './_helpers/loader.interceptor';
import { TokenInterceptor } from './_helpers/token.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { SuccessInterceptor } from './_helpers/success.interceptor';
import { ScrollerModule } from 'primeng/scroller';

import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ToastModule } from 'primeng/toast';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TrackingService } from './_services/tracking.service';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { CaptchaModule } from 'primeng/captcha';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginWithGeoOneSsoComponent } from './login-with-geo-one-sso/login-with-geo-one-sso.component';
import { TrackingServiceMapTiler } from './_services/trackingScreenMaptiler.service';
import { AppErrorHandler } from './analytics/error/app-error-handler';

@NgModule({
    declarations: [
        AppComponent, NotfoundComponent, LoginWithGeoOneSsoComponent,
    ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        HttpClientModule,
        ScrollerModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        CaptchaModule,
        ScrollPanelModule,
        MsAdalAngular6Module.forRoot({
            tenant: environment.SSOAutority,
            clientId: environment.SSOclientId,
            navigateToLoginRequestUrl: false,
            postLogoutRedirectUri: environment.post_logout_redirect_uri,
            redirectUri: environment.post_logout_redirect_uri,
        }),
        ToastModule,
    ],
    providers: [
        CountryService, CustomerService, EventService, IconService, NodeService,
        PhotoService, ProductService,
        { provide: ErrorHandler, useClass: AppErrorHandler },   
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SuccessInterceptor, multi: true },
        AppGlobals,
        AuthGuard,
        LoaderService,
        DatePipe,
        DialogService,
        MessageService,
        TrackingService,
        FormBuilder,
        MsAdalAngular6Service,
        ConfirmationService,
        DynamicDialogConfig,
        TrackingServiceMapTiler
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
